import { MathUtils } from "three";
import { ApexSign } from "../Models/AppModel.js";
import { Utils } from "./Utils.js";
/**
 * Contains functions to format data.
 */
// @dynamic
export class FormatUtils {
    /**
     * Converts an angle in radiants and rounds it.
     */
    static angleRadiants(radiants) {
        return Math.round(MathUtils.radToDeg(radiants));
    }
    /**
     * Creates a string with the name of the angle and the value passed in radiants and converted in degrees. Used mainly by 3d label.
     */
    static angleRadiantsWithNameAndSymbol(name, radiants) {
        return `${name} ${this.angleRadiants(radiants)}°`;
    }
    /**
     * Creates a string with the angle passed in radiants and converted in degrees and adds ° symbol at the ends. Used mainly by 3d label.
     */
    static angleRadiantsWithSymbol(radiants) {
        return `${this.angleRadiants(radiants)}°`;
    }
    /**
     * Rounds the value.
     */
    static distance(value) {
        return Math.round(value);
    }
    /**
     * Rounds the value and adds mm at the ends.
     */
    static distanceWithSymbol(value) {
        return `${this.distance(value)} mm`;
    }
    /**
     * Returns a number with only 2 decimals.
     */
    static roundedNumber(value) {
        return Utils.numberRound(value, 2);
    }
    /**
     * Gets the apex sign name.
     */
    static apexSign(value) {
        return ApexSign[value];
    }
}
//# sourceMappingURL=FormatUtils.js.map